import api from '@/services/api/config';

const path = 'v1/dokument/typ';

export default {
  get: () => api.get(path),
  getById: (id) => api.get(`${path}/${id}`),
};
